import { MESApiService, ResponseMESF, spParameter } from "@dexteel/mesf-core";

export const getBilletsYardStatus = async (): Promise<ResponseMESF> => {
  const apiService = new MESApiService();
  const sqlParameters: spParameter[] = [];

  return await apiService.callV2(
    "[BYI].[GetBilletsLocationsStatusIG]",
    sqlParameters,
  );
};
